import { KibanaLogger } from '@xfinity/kibanajs';
import { flagEnabled } from './featureFlags';

let guid = '';

// Block CPC logging calls to undefined paths BEFORE any fetch happens
// CPC logs to "undefined/log/collect" when envConfig.serviceDomainName is undefined
// Intercept fetch calls
const originalFetch = window.fetch;
window.fetch = function mockFetch(...args) {
  const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
  const urlString = String(url).toLowerCase();
  // Block CPC logging calls to undefined paths
  if (urlString.includes('undefined/log/collect')) {
    // console.debug('[Logger] Blocked CPC logging call to:', url);
    // Return a fake response without making the network call
    return Promise.resolve({ ok: true, status: 204, text: () => Promise.resolve('') });
  }
  // All other requests go through normally
  return originalFetch.apply(this, args);
};

const kibana = new KibanaLogger({
  appname: 'my-account-web',
  component: 'maw_bill_pay',
  sessionID: (window.MAW && window.MAW.sessionID) ? window.MAW.sessionID : 'unknown',
  env: window.MAW?.env,
  // defaultValue: true prevents dropped logs while the remote flag fetch is still
  // pending on initial page load (DarkSwitch resolves flagEnabled to false until then)
  enabled: () => flagEnabled('kibana.enabled', { defaultValue: true })
    && flagEnabled('global.kibana.enabled', { defaultValue: true }),
  logDomains: [
    window.location.host,
    'sdx.qa.xfinity.com',
    'sdx.xfinity.com',
  ],
});

kibana.attachToFetch();

export const setGuid = (currentGuid) => {
  guid = currentGuid;
  kibana.clientData = { ...(kibana.clientData || {}), guid };
};

export const kibanaLog = (en, details = {}) => {
  if (details.event !== 'ajax_response' && details.event !== 'ajax_response_error') {
    kibana.log({ event: en, guid, data: { ...details } });
  }
};

export const kibanaErrorLog = (details = {}) => {
  kibana.errorLog({ ...details, guid });
};

kibana.logErrors();

export const logger = (name) => {
  let enabled = false;

  const l = ['log', 'info', 'error', 'debug', 'warn'].reduce((c, key) => {
    // eslint-disable-next-line no-param-reassign, no-console
    c[key] = (...args) => enabled && console[key].call(console, `[${name}]`, ...args);
    return c;
  }, {
    enable(v) {
      enabled = v;
      return l;
    },
  });
  return l;
};
